import React, {useCallback} from "react";
import { Button, Header } from "../UI";
import { NotificationItem } from "./NotificationItem";
import { useCommonTranslations } from "tds_shared_ui";
import "./NotificationIcon.css";
import PropTypes from "prop-types";
import {useUserContext} from "../../context/UserContext";

export const NotificationList = ({
                                     onClick,
                                     markAsRead,
                                 }) => {
    const { notificationData } = useUserContext();
    const { commonTranslations } = useCommonTranslations();

    const getTranslation = useCallback((key) => {
        if (commonTranslations && commonTranslations[key]) {
            return commonTranslations[key];
        }
        return key;
    }, [commonTranslations]);

    const handleMarkAsRead = () => {
        if (onClick) onClick();
    };

    let smallArray = notificationData.length > 0 ? notificationData.slice() : [];

    return (
        <div className="cart-list notification-list-page">
            <Header level={2}>
                {getTranslation("HEADER_NOTIFICATION_CENTER")}
            </Header>
            {markAsRead === false && notificationData.length > 0 && (
                <div className="clearfix">
                    <Button
                        className="btn-mark-read float-right"
                        onClick={handleMarkAsRead}
                        type="button"
                        variant="link"
                    >
                        {getTranslation("BUTTON_MARK_AS_READ")}
                    </Button>
                </div>
            )}
            {notificationData.length > 0 ? (
                <div className="notification-list">
                    {smallArray.map((notification, i) => (
                        <NotificationItem item={notification} key={i} />
                    ))}
                </div>
            ) : (
                <strong className="text-center">
                    {getTranslation("MESSAGE_NO_NEW_NOTIFICATIONS")}
                </strong>
            )}
        </div>
    );
};

NotificationList.propTypes = {
    onClick: PropTypes.func,
    markAsRead: PropTypes.bool,
};